import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";

/**
 * LegalLayout — shared chrome for /legal/privacy and /legal/terms.
 *
 * These pages exist outside the authenticated shell (no Layout / no
 * navigation bar) so they're readable from the Sign-In page without
 * pushing the user out of the flow, and from Profile once signed in.
 * Design intent: paper background, generous margins, quiet typography.
 */
export default function LegalLayout({ title, effectiveDate, children }) {
  return (
    <div
      className="min-h-screen"
      style={{ background: "linear-gradient(180deg, #f6f1e7 0%, #efe4d0 100%)" }}
      data-testid="legal-layout"
    >
      <header className="max-w-3xl mx-auto px-6 pt-10 pb-6 flex items-center justify-between">
        <Link to="/" className="inline-block" data-testid="legal-brand-link">
          <BrandMark className="text-3xl" />
        </Link>
        <Link
          to="/"
          className="text-[11px] uppercase tracking-[0.24em] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--fg))]"
          data-testid="legal-home-link"
        >
          ← Back
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 pb-24" data-testid="legal-main">
        <div className="text-[11px] uppercase tracking-[0.28em] text-[hsl(var(--muted-foreground))]">
          N8One · Legal
        </div>
        <h1 className="font-display text-4xl md:text-5xl mt-3 leading-tight" data-testid="legal-title">
          {title}
        </h1>
        <p className="mt-3 text-sm text-[hsl(var(--muted-foreground))]" data-testid="legal-effective">
          Effective {effectiveDate}. Last updated {effectiveDate}.
        </p>

        <div className="mt-10 space-y-8 leading-relaxed text-[15px] text-[hsl(var(--fg))]/90 legal-prose">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t hairline text-sm text-[hsl(var(--muted-foreground))] flex flex-wrap items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} Essentialist Dispatch. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <Link to="/legal/privacy" className="hover:text-[hsl(var(--fg))]" data-testid="legal-footer-privacy">
              Privacy Policy
            </Link>
            <Link to="/legal/terms" className="hover:text-[hsl(var(--fg))]" data-testid="legal-footer-terms">
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
